import React from 'react';
import { Dimmer, Loader as SLoader } from 'semantic-ui-react';

export type LoaderSpinnerProps = {
  fullscreen?: boolean;
  name?: string;
};

export const LoaderSpinner = ({
  fullscreen,
  name = 'LOADER_SPINNER',
}: LoaderSpinnerProps) => {
  const className = `axiom-loader-spinner fullscreen-${!!fullscreen}`;

  return (
    <div className={className} data-test={name}>
      <Dimmer active>
        <SLoader>Loading...</SLoader>
      </Dimmer>
    </div>
  );
};
